
import { defineComponent } from 'vue'
import { TrinketLine } from '@/domain/models/TrinketLine'

export default defineComponent({
    name: 'TrinketGridLine',
    props: {
        line: {
            required: true,
            type: Object as () => TrinketLine
        }
    }
})
